import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 * 评分状态
 * @param params
*/

export const getGradeStatus = params => Http.get(`${baseUrl}/chapter/team/grade/score/status`, { params })

/**
 * 填写评分项目反馈
 * @param params
*/

export const writeItem = params => Http.post(`${baseUrl}/chapter/team/grade/score`, params)

/**
 * 评分团队列表
 * @param params
*/

export const getGradeTeamList = params => Http.get(`${baseUrl}/chapter/team/grade/score`, { params })

/**
 * 评分项列表
 * @param params
*/

export const getGradeInfo = params => Http.get(`${baseUrl}/chapter/team/grade/score/info`, { params })

/**
 * 团队排名
 * @param params
*/

export const teamRanking = params => Http.get(`${baseUrl}/chapter/team/grade/top/team`, { params })

/**
 * 个人排名
 * @param params
*/

export const memberRanking = params => Http.get(`${baseUrl}/chapter/team/grade/top/post`, { params })
